import React, { useState } from 'react';
import '../styles/ThesisCard.css';

function ThesisCard({ isAssigned, mailto, thesisName, thesisDirectors, researchAreas, usefulLinks, thesisSummary }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false); // Mantener el estado del hover

  const handleMouseEnter = () => {
    if (!isAssigned) {
      setIsHovering(true); // Activa el estado del hover
    }
  };

  const handleMouseLeave = () => {
    if (!isAssigned) {
      setIsHovering(false); // Desactiva el estado del hover
    }
  };

  const handleCardClick = () => {
    if (!isAssigned) {
      setIsModalOpen(true); // Abre el modal solo si la tarjeta no está asignada
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Cierra el modal
  };

  return (
    <div>
      <div
        className="thesis-card"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleCardClick}
      >
        <div className={`overlay ${isAssigned ? 'taken' : isHovering ? 'visible' : ''}`}>
          <p>{isAssigned ? 'This Thesis Proposal has been taken' : 'This Thesis Proposal is Available'}</p>
        </div>
        <div className="thesis-info">
          <h2 className="thesis-name">{thesisName}</h2>
          <p><strong>Thesis Directors:</strong> {thesisDirectors.join(', ')}</p>
          <p><strong>Research areas:</strong> {researchAreas.join(', ')}</p>
          <p><strong>Useful Links: </strong>{usefulLinks.join(', ')}</p>
          <p><strong>Thesis Details:</strong></p>
          <p>{thesisSummary}</p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          {/* Botón para enviar correo */}
          <button
            className="modal-button email-button"
            onClick={() => (window.location.href = `mailto:${mailto}`)}
          >
            Send Email
          </button>
      
          {/* Correo visible para copiar */}
          <p className="email-text">
            Or copy this email: <strong>{mailto}</strong>
          </p>
      
          {/* Sección de enlaces útiles */}
          <h3>Useful Links</h3>
          <div className="useful-links">
            <ul>
              {usefulLinks.map((link, index) => (
                <li key={index}>
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
      
          {/* Botón para cerrar */}
          <button className="modal-button close-button" onClick={handleCloseModal}>
            Close
          </button>
        </div>
      </div>
      
      )}
    </div>
  );
}

export default ThesisCard;
